<mat-card class="m-4">
  <mat-card-content>
    <span matListItemTitle>{{redemption.redemptionCode}} :lla ei löytynyt lunastusta.</span>
  </mat-card-content>
</mat-card>
